export default __webpack_public_path__ + "static/media/dark-explorer-logo.ba7ca267.svg";